// extracted by mini-css-extract-plugin
module.exports = {"reviewsContainer":"styles_reviewsContainer__4h4mP","starsContainer":"styles_starsContainer__2tWne","title":"styles_title__3_y3K","subtitle":"styles_subtitle__3e1I8"};